import React from 'react';
import { FormattedMessage } from 'react-intl';
import Clickable from '../../../components/clickable/Clickable';
import styles from './login.module.scss';

export default function MailLoginForm({
    handleInputChange,
    handleLogin,
    errors,
    handleInputBlurred,
    blurredFields,
    email,
    handleLoginWithOtp
}) {
  return (
    <form name="loginForm" className={styles.login_form} onSubmit={handleLogin} noValidate>
      <div className={styles.login_form_wrapper}>
        <div className={styles.welcome}>
          {<FormattedMessage id="authentication.login.authentication" defaultMessage="Authentication" />}
        </div>
        <div className={styles.login_message}>Login to your account</div>
        <div className={styles.column_wrapper}>
          <div className={styles.form_column}>
            <label htmlFor="loginPassword">
              <div className={styles.form_control}>
                <input
                  type="text"
                  name="email"
                  noValidate
                  required
                  value={email}
                  onChange={(e) => {
                      handleInputChange('email', e.target.value);
                  }}
                  onBlur={() => handleInputBlurred('email')}
                />
              </div>
              <span className={styles.formLabelText}>Please, enter your email to login</span><br />
              {blurredFields.email && errors.emailEmpty ? (
                <small className={styles.error}>
                  <FormattedMessage id="authentication.login.error.email_empty" defaultMessage="This field cannot be empty" />
                </small>) : null
              }
              {blurredFields.email && errors.emailInvalid ? (
                <small className={styles.error}>
                  <FormattedMessage id="authentication.login.error.email_invalid" defaultMessage="Enter a valid email address" />
                </small>) : null
              }
              {!blurredFields.email || (!errors.emailEmpty && !errors.emailInvalid) ? (
                <small className={styles.empty_error} />) : null}
            </label>
            {!blurredFields.email || (!errors.emailEmpty && !errors.emailInvalid) ? (
              <small className={styles.empty_error} />
            ) : null}
          </div>
        </div>
        {errors.invalidCredentials ? (
          <div className={`${styles.error} ${styles.invalid_credentials}`}>
            <FormattedMessage id="authentication.login.error.invalid_credentials" defaultMessage="Invalid Credentials" />
          </div>) : null}
        <div className={styles.button_wrapper}>
          <button
            type="submit"
            className={styles.button}
          >
            <FormattedMessage id="authentication.login.login" defaultMessage="Login" />
          </button>
        </div>
        <div className={styles.forgot_password_custom}>
          <Clickable onClick={() => handleLoginWithOtp()} className={styles.forgot_password}>
            <FormattedMessage id="authentication.login.with_password4" defaultMessage="Login with Otp" />
          </Clickable>
        </div>
      </div>
    </form>
  );
}
